module.exports = __webpack_public_path__ + "img/logo_image.48df71f4.svg";